import {
  authTokenGet,
  deviceIdGet,
  getCacheVPN,
  localeGet,
  webviewAccessTokenGet,
} from '@codestreet/utils'

import type { ApiRequestHeaders } from './client.types'

export function headersBase(webview: boolean, providedHeaders: ApiRequestHeaders) {
  const { application, version_backend, pwa } = providedHeaders
  const token = webview ? webviewAccessTokenGet() : authTokenGet()?.accessToken
  const headers: { [key: string]: string } = {
    ...(providedHeaders['X-Paywall-Platform'] && {
      'X-Paywall-Platform': providedHeaders['X-Paywall-Platform'],
    }),
    'X-Application': application || '',
    'X-Version-Backend': version_backend || '',
    'X-PWA': pwa || '',
    'X-Device-Id': deviceIdGet(),
    Locale: localeGet(),
    Authorization: token ? `Bearer ${token}` : '',
  }

  if (getCacheVPN() !== undefined) {
    headers['X-Vpn'] = String(getCacheVPN())
  }
  return headers
}
